import { ChevronLeft, Euro, X } from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { Input } from "@components/ui/input";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { updateFinancialFigures } from "@redux/slices/filter";
import { useEffect, useState } from "react";
import { Checkbox } from "@mui/material";
import * as Select from "@radix-ui/react-select";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
interface Props {
  handleClose: () => void;
}

const FinancialFigures: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const financialFigures = useSelector(
    (state: RootState) => state.filter?.financialFigures
  );

  const data = useSelector((state: RootState) => state.filter);

  const [from, setFrom] = useState(financialFigures?.from);
  const [to, setTo] = useState(financialFigures?.to);
  const [size, setSize] = useState(financialFigures?.unknownSize);
  const [currency, setCurrency] = useState(financialFigures?.currency);

  useEffect(() => {
    console.log(financialFigures);
    setFrom(financialFigures?.from);
    setTo(financialFigures?.to);
    setSize(financialFigures.unknownSize);
    setCurrency(financialFigures.currency);
  }, [financialFigures]);

  const handleFromChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10) || 0;
    setFrom(value);
    dispatch(
      updateFinancialFigures({ from: value, to, unknownSize: size, currency })
    );
  };

  const handleToChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10) || 0;
    setTo(value);
    dispatch(
      updateFinancialFigures({ from, to: value, unknownSize: size, currency })
    );
  };
  const handleCheckboxChange = () => {
    const updatedSize = !size;
    setSize(updatedSize);
    dispatch(
      updateFinancialFigures({ from, to, unknownSize: updatedSize, currency })
    );
  };

  const handleCurrencyChange = (value: string) => {
    dispatch(
      updateFinancialFigures({ from, to, unknownSize: size, currency:value })
    );
  };

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Revenue
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <div className="flex gap-4">
          {/* <div className="bg-white w-7/12 rounded-lg px-6 py-4">
            <h4 className="text-lg font-bold flex items-center mb-4">
              Revenue Distribution
            </h4>
            <ColumnChart />
          </div> */}
          <div className="bg-white w-6/12 rounded-lg px-6 py-4">
            <h4 className="text-lg font-bold flex items-center mb-4">
              Revenue Range
            </h4>
            <p className="text-[#71717A] mb-1">From</p>
            <div className="relative">
              <Input
                type="number"
                value={from}
                onChange={handleFromChange}
                placeholder="0"
              />
              {/* <Euro className="absolute right-3 top-2" size={21} /> */}
            </div>
            <p className="text-[#71717A] mb-1 mt-4">To</p>
            <div className="relative">
              <Input
                type="number"
                value={to}
                onChange={handleToChange}
                placeholder="1,000,000,000,000"
              />
              {/* <Euro className="absolute right-3 top-2" size={21} /> */}
            </div>
            <div>
              <div className="flex justify-between items-center mt-7">
                <p className="text-[#71717A] mb-1">Selected range</p>
                <div className="bg-[#D9D9D9] px-8 py-1 text-sm rounded-full">
                  {`${from ? from : 0} ${currency} - ${to ? to : 0}`} {currency}
                </div>
              </div>
              <p className="text-[#71717A] text-sm mb-1 mt-3">Currency</p>
              <Select.Root value={currency} onValueChange={handleCurrencyChange}>
                <SelectTrigger className="SelectTrigger bg-white">
                  <SelectValue placeholder="Select Currency" />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="USD">USD</SelectItem>
                  <SelectItem value="AUD">AUD</SelectItem>
                  <SelectItem value="EUR">EUR</SelectItem>
                </SelectContent>
              </Select.Root>
              <div className="flex items-center mt-3">
                <p className="text-[#71717A] me-3">Revenue Unknown</p>

                <Checkbox
                  checked={size}
                  onChange={handleCheckboxChange}
                  sx={{ color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={() => navigate(-1)} className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default FinancialFigures;
